import { Component, Input } from '@angular/core';
import {
	MatCard,
	MatCardHeader,
	MatCardTitle,
	MatCardContent,
} from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-cards',
	templateUrl: './cards.component.html',
	styleUrls: ['./cards.component.css'],
	imports: [
		MatCard,
		MatCardHeader,
		MatCardTitle,
		MatIconButton,
		MatMenuTrigger,
		MatIcon,
		MatMenu,
		MatMenuItem,
		MatCardContent,
	],
})
export class CardsComponent {
	@Input() title?: string;
	@Input() showTitle = false;
}
